import * as React from 'react';

import type { LatLng } from '../../components';

const CurrentLocationContext = React.createContext<{
  // eslint-disable-next-line no-unused-vars
  setLatLng: (latLng: LatLng) => void;
  latLng?: LatLng;
}>({
  setLatLng: () => {
    /** Do nothing */
  },
});

export const CurrentLocationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [latLng, setLatLng] = React.useState<LatLng | undefined>(undefined);

  return (
    <CurrentLocationContext.Provider value={{ latLng, setLatLng }}>
      {children}
    </CurrentLocationContext.Provider>
  );
};

export const useCurrentLocation = () => {
  return React.useContext(CurrentLocationContext);
};
